<template>
  <span
    v-if="title != null"
    class="title"
    :class="
      variant_color == false ? 'primary-color-title' : 'variant-color-title'
    "
  >
    {{ title }}
  </span>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.title {
  font-style: normal;
  font-weight: 600;
  font-size: 38px !important;
  line-height: 46px;
  text-align: center;
}
@media screen and (min-width: 900px) {
  .primary-color-title {
    background: linear-gradient(0deg, #e0fcff 50%, rgba(255, 255, 255, 0) 50%);
  }

  .variant-color-title {
    background: linear-gradient(0deg, #e0e8f9 50%, rgba(255, 255, 255, 0) 50%);
  }
}
</style>
